<template>
  <draggable
    tag="div"
    ghost-class="ghost"
    :scroll-sensitivity="200"
    :list="mutableValue"
    :group="{ name: 'g1' }"
    class="fts-module-designer dragArea"
    @change="updateRecursive"
  >
    <div v-for="el in mutableValue" :key="el.id" class="module">
      <!-- group -->
      <div class="module-wrapper" :style="style" v-if="el.type == 'group'">
        <div class="module-info">
          <fts-emoji
            append-to-body
            :toggle-size="14"
            v-model="el.emoji" 
            class="module-emoji"
            @input="onChange"
          />
          <fts-contenteditable
            class="module-contenteditable"
            v-model="el.name"
            @input="onChange"
          />
        </div>
      </div>
      <!-- module (menu) -->
      <!-- <div
        class="module-wrapper"
        :class="{
          active: el.id == module.id,
          inactive: el.inactive,
          open: el.open,
          unpublished: !el.published
        }"
        :style="style"
        @mouseover="onHover(el.id)"
        @mouseleave="onHover()"
        @click="openChildren(el)"
        v-else-if="isGroup(el)"
      >
        <div class="module-info">
          <fts-moji :emoji="el.emoji" :size="14" class="module-emoji" v-if="el.emoji" />
          <fts-tippy 
            trigger-class="module-name"
            :options="{ placement: 'top-start' }" 
            :content="el.name"
            class="module-name-wrapper"
          >
            {{el.name}}
          </fts-tippy>
          <div class="module-tag" v-if="el.isProfile || el.isUserCollection">
            <font-awesome-icon :icon="['fas', 'user']" fixed-width/>
          </div>
        </div>
        <div class="module-action-container" v-if="selectedItemId === el.id || el.active">
          <fts-btn
            sm
            icon
            color="secondary"
            box-shadow-none
            class="module-action design-toggle stopPropagation"
            @click="selectModule(el)"
          >
            <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" />
          </fts-btn>
          <fts-dropdown-select
            placement="left-start"
            append-content-class="module-content module-dropdown-menu"
            class="module-action dropdown-toggle"
            :class="{active: el.active}"
            @selected="selectAction($event, el)"
            @show="actionMenuShow(el)"
            @hide="actionMenuHide(el)"
          >
            <fts-btn
              slot="toggle"
              sm
              icon
              color="primary"
              box-shadow-none
              class="module-action stopPropagation"
            >
              <font-awesome-icon :icon="['fas', 'ellipsis-h']" fixed-width />
            </fts-btn>
            <template #menu="{ select, defaultOptionClass}">
              <div class="module-dropdown-option stopPropagation" :class="defaultOptionClass" @click="select('design')">
                <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" fixed-width class="module-dropdown-option-icon"/>
                <div class="module-dropdown-option-name">Design</div>  
              </div>       
              <div class="module-dropdown-option stopPropagation" :class="defaultOptionClass" @click="select('delete')">
                <font-awesome-icon :icon="['far', 'trash-alt']" fixed-width class="module-dropdown-option-icon"/>
                <div class="module-dropdown-option-name">Delete</div>  
              </div>
            </template>
          </fts-dropdown-select>
        </div>
        <font-awesome-icon :icon="['fas', 'caret-right']" fixed-width class="module-toggle" />
      </div> -->
      <!-- module / menu -->
      <router-link
        :to="{ name: 'studio', query: { id: el.id } }"
        custom
        v-slot="{ href }"
        v-else
      >
        <a
          :href="href"
          :style="style"
          class="module-wrapper"
          :class="{
            active: el.id == module.id,
            inactive: el.inactive,
            unpublished: !el.published
          }"
          @mouseover="onHover(el.id)"
          @mouseleave="onHover()"
          @click.prevent="selectModule(el, true)"
        >
          <div class="module-info">
            <!-- emoji -->
            <fts-moji 
              :emoji="el.emoji" 
              :size="14" 
              class="module-emoji" 
              v-if="!!el.emoji" 
            />
            <!-- name -->
            <fts-tippy
              trigger-class="module-name"
              :options="{ placement: 'top-start' }"
              :content="el.name"
              class="module-name-wrapper"
            >
              {{el.name}}
            </fts-tippy>
            <!-- profile -->
            <div class="module-tag" v-if="el.isProfile || el.isUserCollection">
              <font-awesome-icon :icon="['fas', 'user']" fixed-width />
            </div>
          </div>
          <!-- actions -->
          <div class="module-action-container" v-if="selectedItemId === el.id || el.active">
            <!-- design -->
            <fts-btn
              sm
              icon
              color="secondary"
              box-shadow-none
              class="module-action design-toggle stopPropagation"
              @click="selectModule(el)"
            >
              <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" fixed-width />
            </fts-btn>
            <!-- action dropdown -->
            <fts-dropdown-select
              placement="left-start"
              append-content-class="module-content module-dropdown-menu"
              class="module-action dropdown-toggle"
              :class="{active: el.active}"
              @selected="selectAction($event, el)"
              @show="actionMenuShow(el)"
              @hide="actionMenuHide(el)"
            >
              <fts-btn
                slot="toggle"
                sm
                icon
                color="primary"
                box-shadow-none
                class="module-action stopPropagation"
              >
                <font-awesome-icon :icon="['fas', 'ellipsis-h']" fixed-width />
              </fts-btn>
              <template #menu="{select, defaultOptionClass}">
                <div class="module-dropdown-option stopPropagation" :class="defaultOptionClass" @click="select('design')">
                  <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" fixed-width class="module-dropdown-option-icon"/>
                  <div class="module-dropdown-option-name">Design</div>
                </div>
                <div class="module-dropdown-option stopPropagation" :class="defaultOptionClass" @click="select('delete')">
                  <font-awesome-icon :icon="['far', 'trash-alt']" fixed-width class="module-dropdown-option-icon"/>
                  <div class="module-dropdown-option-name">Delete</div>
                </div>
              </template>
            </fts-dropdown-select>
          </div>
        </a>
      </router-link>
      <!-- group child -->
      <fts-module-designer
        :deep="deep + 1"
        class="recursive"
        v-model="el.children"
        @updateRecursive="updateRecursive"
        @module:select="selectModule"
        @module:delete="deleteModule"
        @list:select="selectList"
        @change="onChange"
      />
    </div>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";

import { store as canvasDesignStore } from "../store/canvasDesignStore";
import commons from "../commons/commons";

import FTSContenteditable from "../elements/FTSContenteditable";
import FTSEmoji from "../elements/FTSEmoji";
import FTSMoji from "../elements/FTSMoji";
import FTSProfile from "../elements/FTSProfile";
import FTSBtn from "../elements/FTSBtn";
import FTSTransitionExpand from "../elements/FTSTransitionExpand";
import FTSDropdownSelect from "../elements/FTSDropdownSelect";
import FTSTippy from "../elements/FTSTippy";

export default {
  name: "fts-module-designer",
  props: {
    value: Array,
    deep: {
      type: Number,
      default: 0,
    },
  },
  model: {
    prop: "value",
    event: "updateValue",
  },
  components: {
    draggable,
    "fts-contenteditable": FTSContenteditable,
    "fts-emoji": FTSEmoji,
    "fts-moji": FTSMoji,
    "fts-profile": FTSProfile,
    "fts-btn": FTSBtn,
    "fts-dropdown-select": FTSDropdownSelect,
    "fts-transition-expand": FTSTransitionExpand,
    "fts-tippy": FTSTippy,
  },
  data: () => ({
    selectedItemId: null,
  }),
  computed: {
    mutableValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("updateValue", val);
      }
    },
    style() {
      return this.deep && { 'padding-left': `${(this.deep * 20) + 12}px` };
    },
    module() {
      return canvasDesignStore.state.vector || {};
    },
  },
  methods: {
    isGroup(item) {
      return item.extension && item.extension.menus && item.extension.menus.length;
    },
    selectList(item) {
      this.$emit("list:select", item);
    },
    selectModule(item, stopPropagation) {
      if (commons.elementStopPropagation() && stopPropagation)
        return;

      if (!item.type && item.id)
        this.$emit("module:select", item);
    },
    deleteModule(item) {
      this.$emit("module:delete", item);
    },
    onHover(id) {
      if (id)
        this.selectedItemId = id;
      else
        this.selectedItemId = null;
    },
    openChildren(item) {
      if (commons.elementStopPropagation())
        return;
      
      if (item.open === undefined) 
        this.$set(item, "open", true);
      else 
        item.open = !item.open;
    },
    async selectAction(arg, item) {
      if (arg === 'design')
        this.selectModule(item)
      else if (arg === 'delete')
        this.deleteModule(item);
    },
    actionMenuShow(item) {
      this.$set(item, 'active', true);
    },
    actionMenuHide(item) {
      this.$delete(item, 'active');
    },
    findGroupName(menus, i) {
      const name = `Group ${i}`;
      if (menus.some((x) => x.name == name))
        return this.findGroupName(menus, i + 1);
      else
        return name;
    },
    recursiveProcess(original) {
      let menus = [...original];
      menus.forEach((item) => {
        if (item.children && item.children.length) {
          var modules = item.children.filter((x) => x.module);
          if (modules.length) {
            this.recursiveProcess(item.children);

            if (item.type != "group" && modules.length) {
              let index = original.indexOf(item);
              var children = item.children.filter((x) => !x.module && x.id);

              original.splice(index, 1, {
                id: commons.nanoID(),
                name: this.findGroupName(original, 1),
                type: "group",
                children: [...modules, item],
                emoji: "⚪",
              });
              item.children = children;
            }
          }
        } else if (item.type == "group") {
          let index = original.indexOf(item);
          original.splice(index, 1);
        }
      });
    },
    updateRecursive() {
      let recursiveData = _.cloneDeep(this.mutableValue);
      this.recursiveProcess(recursiveData);
      this.mutableValue = recursiveData;
      if (this.mutableValue && this.mutableValue.length == 0) {
        this.$emit("updateRecursive");
      } else {
        this.onChange();
      }
    },
    onChange() {
      this.$emit("change");
    }
  }
};
</script>

<style lang="scss">
@use "./src/assets/scss/vars" as *;

.fts-module-designer {
  &.recursive {
    min-height: 0.375rem;
    .ghost {
      &::before {
        content: "drop to form a group";
      }
    }
  }
  .ghost {
    background-color: var(--fts-gray-100);
    &::before {
      content: "drop here to rearrange";
      width: 100%;
      display: inline-flex;
      justify-content: center;
      padding: 0.5rem 0.5rem 0;
      color: var(--fts-text);
      font-style: italic;
      font-size: 0.75rem;
      line-height: 1rem;
    }
  }
  .module-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    margin-left: 0.25rem;
    margin-right: 0.25rem;
    padding: 5px 8px;
    border-radius: 0.25rem;
    text-decoration: unset;
    color: var(--drawer);
    cursor: pointer;
    .module-info {
      min-width: 0;
      flex: 1;
      display: flex;
      align-items: center;
      cursor: inherit;
      .module-emoji {
        margin-right: 0.375rem;
        line-height: 1.5;
        cursor: inherit;
      }
      .module-name-wrapper {
        min-width: 0;
        cursor: inherit;
        .module-name {
          @include text-overflow-ellipsis;
          font-size: 0.875rem;
          line-height: 1.5;
          cursor: inherit;
        }
      }
      .module-contenteditable {
        font-size: 0.875rem;
        line-height: 1.5;
      }
      .module-tag {
        margin-left: 0.375rem;
        padding: 0.1rem 0.125rem;
        font-size: 0.625rem;
        border-radius: 0.25rem;
        background-color: var(--drawer-tag-background, var(--drawer-secondary-background));
        color: var(--drawer-tag, var(--drawer-secondary));
      }
    }
    .module-action-container {
      position: absolute;
      right: 0.5rem;
      display: flex;
      align-items: center;
      .module-action {
        &.fts-btn {
          height: 1.25rem;
          width: 1.25rem;
          min-height: 1.25rem;
          min-width: 1.25rem;
          padding: 0.25rem;
          border-radius: 0.25rem;
          font-size: 0.75rem;        
          z-index: 1;
          &.active {
            z-index: 2;
          }
        }
        &:not(:first-child) {
          margin-left: 0.375rem;
        }   
      }
    }
    .module-toggle {
      margin-left: 0.5rem;
      font-size: 0.875rem;
      color: inherit;
      transition: all 0.3s;
    }
    &.open {
      .module-toggle {
        transform: rotate(90deg);
      }
    }
    &:hover {
      background-color: var(--drawer-hover-background);
      color: var(--drawer-hover);
    }
    &.active {
      background-color: var(--drawer-active-background);
      color: var(--drawer-active);
    }
    &.inactive {
      .module-info {
        .module-emoji {
          filter: grayscale(1);
        }
        .module-name {
          color: var(--fts-gray-400);
        }
      }
    }
    &.unpublished {
      .module-info {
        opacity: 0.5;
      }
    }
  }
}
/* module dropdown menu */
.module-content.module-dropdown-menu {
  width: 120px;
  .module-dropdown-option {
    min-width: 0;
    display: flex;
    align-items: center;
    .module-dropdown-option-icon {
      margin-right: .575rem;
      color: var(--fts-gray-400);
    }
    .module-dropdown-option-name {
      @include text-overflow-ellipsis;
    }
  }
}
</style>